import { render, staticRenderFns } from "./OutsideClickHandler.vue?vue&type=template&id=b1064384&lang=pug"
import script from "./OutsideClickHandler.vue?vue&type=script&lang=js"
export * from "./OutsideClickHandler.vue?vue&type=script&lang=js"
import style0 from "./OutsideClickHandler.vue?vue&type=style&index=0&id=b1064384&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports